import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Table } from "@opensea/ui-kit";
import { ReceiptDisplay } from "../../../../components/Receipt";
import { MintTableCollectionFragment, MintTableDropFragment } from "./MintTable.fragment";
import { MintTableRow } from "./MintTableRow";
import { MintTableTotal } from "./MintTableTotal";
export const MintTable = t0 => {
  const $ = _c(21);
  const {
    collection: collectionKey,
    drop: dropKey,
    tokenInputs,
    view
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(MintTableCollectionFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] !== dropKey) {
    t2 = readFragment(MintTableDropFragment, dropKey);
    $[2] = dropKey;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const drop = t2;
  let t3;
  if ($[4] !== tokenInputs || $[5] !== view) {
    t3 = {
      tokenInputs,
      view
    };
    $[4] = tokenInputs;
    $[5] = view;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== collection || $[8] !== drop) {
    t4 = [{
      collection,
      drop
    }];
    $[7] = collection;
    $[8] = drop;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <Table context={t3} itemKey={_temp} items={t4} renderRow={MintTableRow} size="xl" />;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const receipt = t5;
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{}];
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== collection || $[15] !== drop || $[16] !== tokenInputs) {
    t7 = <Table itemKey={_temp2} items={t6} renderRow={() => <MintTableTotal collection={collection} drop={drop} tokenInputs={tokenInputs} />} />;
    $[14] = collection;
    $[15] = drop;
    $[16] = tokenInputs;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const receiptTotal = t7;
  let t8;
  if ($[18] !== receipt || $[19] !== receiptTotal) {
    t8 = <ReceiptDisplay receipt={receipt} receiptTotal={receiptTotal} />;
    $[18] = receipt;
    $[19] = receiptTotal;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp(item) {
  return item?.collection.id;
}
function _temp2(_, index) {
  return index;
}